import { Box, styled } from "@mui/material";
// import bgLogin from "../../../assets/img/bg-login.png";
// import { useLocation } from "react-router-dom";

interface HomePageWrapperProps {
  children?: React.ReactNode;
}

const HomePageWrapper: React.FC<HomePageWrapperProps> = ({
  children,
  ...rest
}) => {
  // const location = useLocation();
  const HomePageWrapperBox = styled(Box)(() => ({
    height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    overflow: "hidden",
    backgroundPosition: "center left",
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `
  linear-gradient(
    135deg,
    #ffffff 0%,
    #fafafa 5%,
    #ffffff 5%,
    #fafafa 10%,
    #ffffff 10%,
    #fafafa 15%,
    #ffffff 15%,
    #fafafa 20%,
    #ffffff 20%,
    #fafafa 25%,
    #ffffff 25%,
    #fafafa 30%,
    #ffffff 30%,
    #fafafa 35%,
    #ffffff 35%,
    #fafafa 40%,
    #ffffff 40%,
    #fafafa 45%,
    #ffffff 45%,
    #fafafa 50%,
    #ffffff 50%,
    #fafafa 55%,
    #ffffff 55%,
    #fafafa 60%,
    #ffffff 60%,
    #fafafa 65%,
    #ffffff 65%,
    #fafafa 70%,
    #ffffff 70%,
    #fafafa 75%,
    #ffffff 75%,
    #fafafa 80%,
    #ffffff 80%,
    #fafafa 85%,
    #ffffff 85%,
    #fafafa 90%,
    #ffffff 90%,
    #fafafa 95%,
    #ffffff 95%,
    #fafafa 100%
  )
`,
  }));

  return <HomePageWrapperBox {...rest}>{children}</HomePageWrapperBox>;
};
export default HomePageWrapper;
